import { ElMessage } from 'element-plus';

function success(message: string) {
  ElMessage({
    type: 'success',
    message,
    showClose: true,
  });
}

export default success;
